// Brand switcher configuration. Destination values are isolated here so real
// URLs/routes can be dropped in later without touching the UI components.
//
// Sutramay is this website — "href" is an internal route.
// Dvita has no confirmed live destination yet, so "href" stays null and the
// switcher renders it as a non-clickable, clearly-labeled "Coming soon" entry
// rather than linking anywhere fake or broken.
const brands = [
  {
    id: "sutramay",
    name: "Sutramay",
    href: "/",
    external: false,
  },
  {
    id: "dvita",
    name: "Dvita",
    href: null,
    external: false,
  },
];

export default brands;
